import { ApiSchema } from "@/api/ApiClient";
import { GenericModelApi } from "./GenericModelApi";
import { SalemanFormData } from "@/formTypes/SalemanFormDataType";

export type SalemanDataType = Partial<ApiSchema["Saleman"]["type"] & SalemanFormData>;
export const SalemanApi = new GenericModelApi<"Saleman", SalemanDataType>("Saleman", "nombre");